import { render, staticRenderFns } from "./DeliverySpaceDetailContractList.vue?vue&type=template&id=94a0aad6&"
import script from "./DeliverySpaceDetailContractList.vue?vue&type=script&lang=ts&"
export * from "./DeliverySpaceDetailContractList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports